<template>

    <BaseContainer class="dnnCloud-comorizeList-box" :loading="listLoading" :isHasPageFt="!listLoading">
      <template v-slot:hd>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-form :inline="true" :model="souchs" @submit.native.prevent>
            <!-- <el-select v-model="value" placeholder="请选择" @change="changeSouch" clearable>
              <el-option v-for="item in options" :key="item.value" 
                :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->
            <el-form-item>
              <el-input  v-model="searchText"  placeholder="用户 / 手机号 / 名称 / 企业" style="width:200px;"  @keyup.enter.native="getList(1)"></el-input>
            </el-form-item>

            <el-form-item>
               <el-select v-model="souchs.souType" placeholder="类型" style="width:200px;" clearable >
                 <el-option v-for="item in types" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-model="souchs.status" placeholder="状态" style="width:200px;" clearable >
               <el-option v-for="item in types2" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item v-if="userInfo.type == 1">
              <SelectCommon  placeholder="客户经理" style="width: 100%" :clearable="true" apiPath="/tbAdminuser/manageList" :keys="{label: 'name', value: 'id'}" @change="(value, datas) => handleSelectCommon(value, datas, 'managerAdminuser')" />
            </el-form-item>

            <!-- <el-form-item>
              <el-input v-show="disSouch" v-model="proName"  @keyup.enter.native="getList(1)" style="width:200px;"></el-input>
              <el-select v-show="disType1" v-model="typeValue" placeholder="请选择" style="width:200px;" clearable >
                <el-option v-for="item in types" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-show="disType2" v-model="typeValue2" placeholder="请选择" style="width:200px;" clearable >
                <el-option v-for="item in types2" :key="item.value" 
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item> 
              <el-button type="primary" size="medium" v-on:click="getList(1)">查询</el-button>
            </el-form-item>
          </el-form>
          <!-- <el-tag :key="tag" v-for="tag in dynamicTags" closable 
            :disable-transitions="false" @close="handleClose(tag)"> 
              {{tag}} 
          </el-tag>
          <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button> -->
        </el-col>
      </template>

      <template v-slot:main>
         <!--列表-->
        <el-table :data="dataList" highlight-current-row  @selection-change="selsChange" :height="maxTbHeight"
          style="width: 100%;" :header-cell-style="getRowClass" @sort-change="handleSortChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column type="index" :index="indexMethod" label="序号" width="80">
            <template slot-scope="scope">
                <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" min-width="200" sortable="custom" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="productname" label="名称" min-width="120" sortable="custom" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="companyname" label="企业" min-width="150" sortable="custom" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userdeptname" label="部门" min-width="150" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{ scope.row.userdeptname || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="用户" min-width="100" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{ scope.row.name || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="scope">
                <span>{{ scope.row.phone || '-' }}</span>
            </template>
          </el-table-column>
         <el-table-column prop="typename" label="类型" min-width="100" sortable="custom" show-overflow-tooltip>
             <template slot-scope="scope">
                <span class="myTag" :class="scope.row.typename == '试用'? 'success': 'primary' " > {{scope.row.typename}} </span>
             </template>
          </el-table-column>

          <el-table-column prop="usingstatus" label="状态" min-width="100" sortable="custom" show-overflow-tooltip>
             <template slot-scope="scope">
                <span class="myTag" :class="['2', '3'].includes(scope.row.usingstatus)? '': 'primary' " > {{scope.row.usingstatusname}} </span>
             </template>
          </el-table-column>
          <el-table-column prop="effectivetime" label="生效时间" min-width="180" sortable="custom">
          </el-table-column>
          <el-table-column prop="duetime" label="到期时间" min-width="180" sortable="custom">
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="120" style="text-algin:center">
            <template slot-scope="scope">
              <span class="operate">
                  <el-tooltip effect="dark" content="相关订单" placement="top">
                    <span class="dnnfont iconfile-Business"  @click="handleAbout(scope.$index,scope.row)"></span>
                  </el-tooltip>

                   <template v-if="scope.row.usingstatus !=2">
                      <!-- <el-tooltip effect="dark" content="续费" placement="top">
                        <span class="dnnfont iconclock" @click="handleEdit(scope.$index, scope.row)"></span>
                      </el-tooltip> -->
                      
                      <el-tooltip effect="dark" content="禁用" placement="top"  v-if="!scope.row.usingstatus2">
                        <span class="dnnfont icondisabled"  @click="handleDel(scope.$index, scope.row)"></span>
                      </el-tooltip>

                      <el-tooltip effect="dark" content="启用" placement="top"  v-else>
                        <span class="dnnfont iconaccomplish"  @click="handleOpen(scope.$index, scope.row)"></span>
                      </el-tooltip>
                   </template>

              </span>
              <!-- <el-button type="success"  size="small" @click="handleEdit(scope.$index, scope.row)">续费</el-button>
              <el-button type="default" size="small"  @click="handleAbout(scope.$index, scope.row)">
                相关订单
              </el-button>
              <el-button v-if="!scope.row.usingstatus2" type="danger" size="small" @click="handleDel(scope.$index, scope.row)">禁用</el-button>
              <el-button v-else type="primary" size="small" @click="handleOpen(scope.$index, scope.row)">启用</el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <!--续费界面-->
        <el-dialog class="model-edit model-xf-box" width="800px" title="续费" :visible.sync="editFormVisible" :close-on-click-modal="false" >
          <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true"  @submit.native.prevent>
              <el-form-item label="订单账户:" >{{ orderUser }}
                <!-- <el-input disabled v-model="orderUser"  style="width:300px;"></el-input> -->
              </el-form-item>
            </el-form>
          </el-col>
          <el-table :data="dataList2" highlight-current-row v-loading="editlistLoading" 
            style="width: 100%;" :header-cell-style="getRowClass" >
            <el-table-column type="index" :index="indexMethod2" label="序号" width="80">
              <template slot-scope="scope">
                  <span>{{(pageNumber2 - 1) * pageSize2 + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="logo2" header-align="center" align="center" width="100px" label="图片">
              <template slot-scope="scope">
                <!-- <el-popover placement="right" > -->
                  <!-- <img :src="scope.row.logo"/> -->
                  <img slot="reference" :src="scope.row.logo2" :alt="scope.row.logo2" class="tpimg">
                <!-- </el-popover> -->
              </template>
            </el-table-column>
            <el-table-column prop="id" label="ID" min-width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="100"  show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="productid" label="订单ID" min-width="140" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="price2" label="单价(元)" min-width="100"  show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="purchaseMonth" label="续费时长(月)" min-width="120"  show-overflow-tooltip>
              <template slot-scope="{row,$index}">
                  <el-input  type="number" min="1"  @blur="loseFcousMonth(1, row)" 
                    v-model="row.purchaseMonth">
                  </el-input>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-col :span="24" class="toolbar" style="border:1px solid #dfe6ec;margin-top:0;">
          <el-pagination 
              layout="sizes, prev, pager, next"
              :page-sizes="[10, 20, 30, 50,100]"
              :current-page="pageNumber2" 
              @current-change="handleCurrentChange2" 
              @size-change="handleSizeChange2"
              :page-size="pageSize2" 
              :total="total2" 
              style="float:right;">
            </el-pagination></br>
          </el-col> -->
          <el-col :span="24" class="toolbar" style="position: relative;padding-bottom: 0px;margin-top:0px;height:80px;">
            <el-form :inline="true"  @submit.native.prevent >
              <el-checkbox class="el-checkbox1" v-model="checked" @change="checkboxOnclick"> 试用订单</el-checkbox>
              <el-form-item label="总价:" class="Auto_allPrice">
                <el-input  @blur="priceloseF()" class="price"  :disabled="disCheckBox"
                    v-model="allPrice" style="width:120px;z-index:9999">
                </el-input>
              </el-form-item>
              <el-form-item label="预估价格:" class="Auto_ygPrice">
                {{ygPrice}} 元
              </el-form-item>
            </el-form>
          </el-col>

          <div slot="footer" class="dialog-footer" style="text-align:center">
            <el-button @click.native="editFormVisible = false">取消</el-button>
            <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
          </div>
        </el-dialog>

        <Detail 
          :adminVisible="adminVisible" 
          v-if="adminVisible" 
          :authProductId="detailOrderId"
          @adminVisibleClose="adminVisibleClose"
        />
      </template>

      <template v-slot:ft>
          <!--工具条-->
          <el-col :span="24" class="toolbar" >
            <el-pagination  
              layout="sizes, prev, pager, next"
              :page-sizes="[10, 20, 30, 50,100]"
              :current-page="pageNumber" 
              :page-size="pageSize" 
              :total="total" 
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              style="float:right;">
            </el-pagination>
            <el-button type="danger" size="medium" :disabled="sels1.length===0" class="float_left"  @click="handleDel()">
              禁用
            </el-button>
            <el-button type="primary" size="medium" :disabled="sels3.length===0" class="float_left"  @click="handleOpen()">
              启用
            </el-button>
            <!-- <el-button type="success" :disabled="sels.length===0" class="float_left"  @click="handleEdit()"> 续费</el-button> -->
             
            
          </el-col>
      </template>
    </BaseContainer>
    
</template>
<script>
import { mapGetters } from 'vuex'
import { API__code, API_Auth,imgURLs} from '../../../api/index.js';
import Detail from './detail';
import BaseContainer from '@/components/BaseContainer'
import SelectCommon from '@/components/SelectCommon'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  data(){
    return {
      adminVisible:false,
      detailOrderId:false,
      checkType:'',
      disCheckBox:false,
      checked: false,
      detailIDS:'',
      pruductJson:[],
      companyid:'',
      allPrice:0,
      orderUser:'',
      orderId:'',
      dataList2:[],
      pageNumber2:1,
      pageSize2:10,
      total2:0,
      editlistLoading:false,
      editFormVisible:false,
      editLoading:false,
      editForm:{},
      ygPrice:0,
      allPrice:0,

      disSouch:true,
      disType1:false,
      disType2:false,
      sels:[],
      sels1:[],
      sels3:[],
      token:'',
      checkCode:"",
      id:"",
      listLoading:false,
      dataList:[],
      pageNumber:1,
      pageSize: 20,
      total:0,
      souchs:{
        id:'',
        phone:'',
        name:'',
        souType:'',
        status:"",
      },
      proName:'',
      options: [
        {value: 'ID',label: 'ID'}, 
        {value: '用户',label: '用户'},
        {value: '手机号',label: '手机号'},
        {value: '企业',label: '企业'},
        {value: '名称',label: '名称'},
        {value: '类型',label: '类型'},
        {value: '状态',label: '状态'},
      ],
      value: '',
      types:[
        {value: '1',label: '试用'},
        {value: '2',label: '正式'},
      ],
      types2:[
        {value: '1',label: '正常使用'},
        {value: '2',label: '到期'},
        {value: '3',label: '禁用'}
      ],
      typeValue:'',
      typeValue2:'',
      dynamicTags: [],
      orderType:"",
      orderStr:'',
      searchText:'',
      managerAdminuser: '',  // 新增客户经理过滤
    }
  },

   computed: {
    ...mapGetters(['userInfo', ]),
  },

  components: {
    BaseContainer,
    Detail,
    SelectCommon
  },

  methods: {

    // 客户经理过滤
    handleSelectCommon(value, datas, key) {
      this.managerAdminuser = value[0]
    },
    
    adminVisibleClose(type){
      this.adminVisible = false;
    },
    handleAbout(index,item){
      this.detailOrderId = item.id;
      this.adminVisible = true;
    },
    checkboxOnclick:function(){
      if(this.checked){
        this.disCheckBox = true;
      }else{
        this.disCheckBox = false;
      }
    },
    priceloseF:function(){
      if(this.allPrice){
        if(isNaN(this.allPrice)){
          this.allPrice = this.allPrice.replace(/[^\.\d]/g,'');
        }
        if (parseFloat(this.allPrice).toString() == "NaN") {
          this.$message.error("指标数为大于0的数, 请重新输入");
            return;
        }else if( this.allPrice <0){
          this.$message.error("指标数为大于0的数, 请重新输入");
          this.allPrice = 0;
          return;
        }else{
          this.allPrice = parseFloat(this.allPrice);
          this.allPrice = (this.allPrice).toLocaleString();
        }
      }else{
        this.allPrice = 0;
        return;
      }
    },
    loseFcousMonth:function(index,row){
      if(row.purchaseMonth){
        var falg = this.isInteger(row.purchaseMonth);
        if(!falg){
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        if(row.purchaseMonth < 0){
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        this.ygPrice = 0;
        for(var i=0;i<this.dataList2.length;i++){
          if(this.dataList2[i].purchaseMonth && this.dataList2[i].price){
            this.ygPrice = parseInt(this.ygPrice) + parseInt(this.dataList2[i].purchaseMonth) * parseInt(this.dataList2[i].price);
          }
        }
        if(this.ygPrice){
          this.ygPrice = parseFloat(this.ygPrice);
          this.ygPrice = (this.ygPrice).toLocaleString();
        }
      }
    },
    isInteger:function(obj) {
      obj = parseFloat(obj);
      return Math.floor(obj) === obj
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "id"){
          this.orderStr = "idpx";
        }else if(val.prop == "phone"){
          this.orderStr = "phonepx";
        }else if(val.prop == "name"){
          this.orderStr = "namepx";
        }else if(val.prop == "productname"){
          this.orderStr = "productnamepx";
        }else if(val.prop == "typename"){
          this.orderStr = "typepx";
        }else if(val.prop == "createtime"){
          this.orderStr = "createtimepx";
        }else if(val.prop == "duetime"){
          this.orderStr = "duetimepx";
        }else if(val.prop == "usingstatus1"){
          this.orderStr = "statuspx";
        }else if(val.prop == "userdeptname"){
          this.orderStr = "userdeptnamepx";
        }

        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch:function(val){
      if(val == "类型"){
        this.disSouch = false;
        this.disType1 = true;
        this.disType2 = false;
        this.proName = '';
        this.typeValue=this.souchs.souType;
      }else if(val == "状态"){
        this.disSouch = false;
        this.disType1 = false;
        this.disType2 = true;
        this.proName = '';
        this.typeValue2 = this.souchs.status;
      }else if(val == "ID"){
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.id;
      }else if(val == "手机号"){
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.phone;
      }else if(val == "用户"){
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.name;
      }else if(val == "名称"){
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.productname;
      }else if(val == '企业'){
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.companyname;
      }else if(val == '部门'){
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.userdeptname;
      }
    },
    getList:function(val){
      if(val == 1){
        this.pageNumber = 1;
      }
      if(this.value == "ID"){
        this.souchs.id = this.proName;
      }
      if(this.value == "手机号"){
        this.souchs.phone = this.proName;
      }
      if(this.value == "用户"){
        this.souchs.name = this.proName;
      }
      if(this.value == "名称"){
        this.souchs.productname = this.proName;
      }
      if(this.value == '企业'){
        this.souchs.companyname = this.proName;
      }
      if(this.value == '部门'){
        this.souchs.userdeptname = this.proName;
      }
      if(this.value == "类型"){
        this.souchs.souType = this.typeValue;
      }
      if(this.value == "状态"){
        this.souchs.status = this.typeValue2;
      }
      
      var flag = true;
      if(val == 1){
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
        id:this.souchs.id,
        name:this.souchs.name,
        phone:this.souchs.phone,
        productname:this.souchs.productname,
        companyname:this.souchs.companyname,
        userdeptname:this.souchs.userdeptname,
        type:this.souchs.souType,
        status:this.souchs.status,
        orderType: this.orderType,
        orderStr: this.orderStr,
        accountType:1,
        searchText: this.searchText,
        managerAdminuser: this.managerAdminuser,
        role: this.userInfo.type,
        userId: this.userInfo.id,
      }
      this.listLoading = true;
      API_Auth.getAutoList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          for(var i=0;i<res.data.data.list.length;i++){
            if(res.data.data.list[i].usingstatus == 1){
              res.data.data.list[i].usingstatus1 = "正常使用"
            } else if(res.data.data.list[i].usingstatus == 3){
              res.data.data.list[i].usingstatus1 = "禁用"
              res.data.data.list[i].usingstatus2 = true;
            }else if(res.data.data.list[i].usingstatus == 2){
              res.data.data.list[i].usingstatus1 = "过期"
            }
          }
          this.dataList = res.data.data.list;
          this.total = res.data.data.totalRow;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },
    delTags:function(){
      this.souchs = {},
      this.souchs.souType = '';
      this.souchs.status = '';
      this.value = '';
      this.proName = '';
      this.typeValue = '';
      this.typeValue2 = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose(tag) {
      if(tag == "ID"){
        this.souchs.id ="";
        if(this.value == "ID"){
          this.proName = '';
        }
      }
      if(tag == "用户"){
        this.souchs.name ="";
        if(this.value == "用户"){
          this.proName = '';
        }
      }
      if(tag == "手机号"){
        this.souchs.phone ="";
        if(this.value == "手机号"){
          this.proName = '';
        }
      }
      if(tag == "名称"){
        this.souchs.productname="";
        if(this.value == "名称"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs.companyname="";
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      if(tag == "部门"){
        this.souchs.userdeptname="";
        if(this.value == "部门"){
          this.proName = '';
        }
      }
      if(tag == "类型"){
        this.souchs.souType ="";
        this.typeValue = ''
      }
      if(tag == "状态"){
        this.souchs.status ="";
        this.typeValue2 = ''
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    handleSizeChange2(val) {
			this.pageSize2 = val;
			this.handleEdit();
		},
    handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.handleEdit();
    },
    handleOpen:function(index,row){
      let _this = this;
      this.$confirm('确认启用吗?', '提示', {
        type: 'warning'
      }).then(() => {
        var ids;
        if(row){
          ids = row.id;
        }else{
          ids = _this.sels3.map(item => item.id).toString();
        }
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          ids:ids,
          usingstatus:1,
        }
        API_Auth.delAutoList(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '启用成功',
              type: 'success'
            });
            this.getList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        })
      }).catch(() => {
      });;
    },
    //禁用
    handleDel:function(index,row){
      this.$confirm('确认禁用吗?', '提示', {
        type: 'warning'
      }).then(() => {
        var ids;
        if(row){
          ids = row.id;
        }else{
          ids = this.sels1.map(item => item.id).toString();
        }
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          ids:ids,
          usingstatus:3,
        }
        API_Auth.delAutoList(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '禁用成功',
              type: 'success'
            });
            this.getList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        })
      }).catch(() => {
      });;
    },
    handleEdit:function(index,row){
      this.allPrice = 0;
      this.ygPrice = 0;
      var ids2;
      var nameds = '';
      var phoneds= '';
      if(!row){
        for( var i=0;i < this.sels.length; i++){
          if(this.sels[0].companyid != this.sels[i].companyid){
            this.$message.error('请选择同一用企业的订单！');
            return;
          }
        }
        this.companyid = this.sels[0].companyid;
        if(!this.sels[0].name || this.sels[0].name == null){
          this.sels[0].name = "";
        }
        if(!this.sels[0].phone || this.sels[0].phone == null){
          this.sels[0].phone = "";
        }
        if(this.sels[0].name){
          nameds = this.sels[0].name
        }
        if(this.sels[0].phone){
          phoneds = this.sels[0].phone
        }
        this.orderUser = nameds + "" + phoneds;
        ids2 = this.sels.map(item => item.id).toString();
      }else{
        ids2 = row.id;
        this.companyid = row.companyid;
        if(row.name){
          nameds = row.name
        }
        if(row.phone){
          phoneds = row.phone
        }
        this.orderUser = nameds + "" + phoneds;
      }
      this.dataList2 = [];
      this.getDetial(ids2);
      this.editFormVisible = true;
    },
    editSubmit:function(){
      for(var i=0;i<this.dataList2.length;i++){
        if(!this.dataList2[i].purchaseMonth){
          this.$message.error('列表中的续费时长(月)，不可为空！');
          return;
        }
      }
      if(!this.checked){
        this.checkType = 2;
        if(!this.allPrice || this.allPrice == 0){
          this.$message.error('总价不可为空或者0！');
          return;
        }else{
          if(isNaN(this.allPrice)){
            this.allPrice = this.allPrice.replace(/[^\.\d]/g,'');
          }
        }
      }else{
        this.checkType = 1;
        this.allPrice = 0;
      }
      this.pruductJson = [];
      for(var i=0;i<this.dataList2.length;i++){
        // if(this.dataList2[i].purchaseMonth && this.dataList2[i].price){
        //   this.allPrice = this.allPrice + parseInt(this.dataList2[i].purchaseMonth) * (this.dataList2[i].price);
        // }
        var jsonid = [this.dataList2[i].id];
        var jsons = {
          "authorizedProductId":jsonid,
          "singlePrice":this.dataList2[i].price,
          "productId":this.dataList2[i].productid,
          "purchaseMonth":this.dataList2[i].purchaseMonth,
          "purchaseNum":"1",
          "productName":this.dataList2[i].name
        }
        this.pruductJson.push(jsons);
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        companyid:this.companyid,
        price:this.allPrice,
        pruductJson:JSON.stringify(this.pruductJson),
        adminuserid:this.id,
        type:this.checkType,
      }
      this.editLoading = true;
      API_Auth.autoOrder(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '续费成功',
            type: 'success'
          });
          this.getList();
          this.editFormVisible = false;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.editLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.editLoading = false;
      });
    },
    getDetial:function(ids){
      this.detailIDS = ids;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        ids:ids,
        // pageNumber:this.pageNumber2,
        // pageSize:this.pageSize2,
        // listType:'page',
      }
      this.editlistLoading = true;
      API_Auth.autoDetail(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          for(var i=0;i<res.data.data.length;i++){
            if(res.data.data[i].logo){
              // res.data.data[i].logo2 = imgURLs + res.data.data[i].logo;
              res.data.data[i].logo2 = res.data.data[i].logo;
            }
            if(res.data.data[i].price){
              res.data.data[i].price = parseFloat(res.data.data[i].price);
              res.data.data[i].price2 = (res.data.data[i].price).toLocaleString();
            }
          }
          // this.total2 = res.data.data.totalRow;
          this.dataList2 = res.data.data;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.editlistLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.editlistLoading = false;
      })
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*this.pageSize;
    },
    indexMethod2(index) {
      return (index+1)+(this.pageNumber2-1)*this.pageSize2;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    selsChange: function (row) {
      this.sels1 = [];
      this.sels3 = [];
      for(var i=0;i<row.length;i++){
        if(row[i].usingstatus == "1"){
          var json1 = {"id":row[i].id};
          this.sels1.push(json1);
        }
        if(row[i].usingstatus == "3"){
          var json3 = {"id":row[i].id};
          this.sels3.push(json3);
        }
      }
      this.sels = row;
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
          var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
              var arr2 = arr[i].split('='); //再次切割
              //判断查找相对应的值
              if (arr2[0] == 'dnnyptadmin_token') {
                  this.token = arr2[1]; //保存到保存数据的地方
              } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                  this.checkCode = arr2[1];
              } else if (arr2[0] == 'dnnyptadmin_id') {
                  this.id = arr2[1];
              }
          }
      }
    }
  },
  mounted(){
    this.getList();
  },
  created(){
    this.getCookie();
  },

}
</script>
<style lang="scss">
.dnnCloud-comorizeList-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
.model-xf-box {
  .el-dialog__body {
    min-height: 260px;
  }
}

</style>
<style scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.float_left{
	float: left;
}
.Auto_allPrice {
  position: absolute;
  right: 0px;
  top: 40px;
  margin-bottom: 0;
}
.Auto_ygPrice{
  position: absolute;
  right: 280px;
  top: 40px;
  margin-bottom: 0;
}
.el-checkbox1{
  position: relative;
  float: right;
  padding: 10px;
}

</style>



// WEBPACK FOOTER //
// ComorizeList.vue?63f05cb3